import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from '../../styles/components/UI/Button.module.css'

const Button = ({ className, containerElement, isLoading, children, ...otherProps }) => {
  const Container = containerElement

  const buttonClassName = classnames(styles.button, className, {
    [styles.buttonLoading]: isLoading
  })

  const a11yProps = {
    'aria-label': isLoading ? 'Carregando' : null
  }

  return (
    <Container className={buttonClassName} disabled={isLoading} {...a11yProps} {...otherProps}>
      {children}
      <div className={styles.loader} />
    </Container>
  )
}

Button.propTypes = {
  containerElement: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
  isLoading: PropTypes.bool
}

Button.defaultProps = {
  containerElement: 'button',
  isLoading: false
}

export default Button
